var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgCantineIcon = function SvgCantineIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 37 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.461 33.581a5.098 5.098 0 1 0 0-10.195 5.098 5.098 0 0 0 0 10.195ZM8.461 46.852a6.348 6.348 0 1 0 0-12.696 6.348 6.348 0 0 0 0 12.696Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.323 26.953s1.359 3.898 1.914 6.852c1.225 6.533-.99 9.295-.99 9.295M3.612 26.953s-1.358 3.898-1.914 6.852c-1.224 6.533.99 9.295.99 9.295M8.468 63.229a5.098 5.098 0 1 0 0-10.195 5.098 5.098 0 0 0 0 10.195ZM8.468 58.131V46.724",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.659 53.072v-27.74h-.013c0-.108.02-.223.02-.332 0-4.09-2.45-7.604-5.966-9.161V5.47a3.706 3.706 0 0 0-3.707-3.706 3.706 3.706 0 0 0-3.706 3.707v10.086c-3.892 1.378-6.68 5.079-6.68 9.442 0 .115.012.224.019.332h-.02v28.314h.026c.236 5.328 4.62 9.583 10.004 9.583 5.385 0 9.768-4.25 10.004-9.583h.012v-.312c0-.045.007-.09.007-.134 0-.045 0-.09-.007-.134l.007.006Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.642 63.229c5.532 0 10.017-4.485 10.017-10.017 0-5.532-4.485-10.016-10.017-10.016-5.532 0-10.016 4.484-10.016 10.016S20.11 63.23 25.642 63.23Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
};
var Memo = /*#__PURE__*/memo(SvgCantineIcon);
export { Memo as ReactComponent };
export default "/_next/static/svg/74be59f6bd911f4e4b3e5c33e8342e63.svg";